// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1182":"8778ed18","1407":"451dc76a","5113":"1cded379","6002":"3a592ac6","6641":"7e0dc8fe","9161":"451dc76a"}[chunkId] + ".chunk.css";
};